import { motion, useScroll, useTransform } from 'framer-motion';
import { useRef } from 'react';

const Hero = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ['start start', 'end start'],
  });
  const contentY = useTransform(scrollYProgress, [0, 1], ['0%', '22%']);
  const opacity = useTransform(scrollYProgress, [0, 0.65], [1, 0]);
  const bgY = useTransform(scrollYProgress, [0, 1], ['0%', '12%']);

  const scrollTo = (href) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <section id="top" className="hero hero--classic" ref={ref}>
      <motion.div className="hero__classic-bg" style={{ y: bgY }} aria-hidden="true">
        <div className="hero__classic-wash" />
        <div className="hero__classic-grid" />
        <div className="hero__classic-orb hero__classic-orb--a" />
        <div className="hero__classic-orb hero__classic-orb--b" />
        <div className="hero__classic-frame" />
        <div className="hero__grain" />
      </motion.div>

      <motion.div className="hero__content" style={{ y: contentY, opacity }}>
        <motion.p
          className="hero__kicker"
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1], delay: 0.1 }}
        >
          Software Engineer · Israel
        </motion.p>

        <motion.p
          className="hero__name"
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1], delay: 0.18 }}
        >
          Ibrahem Hurani
        </motion.p>

        <motion.h1
          className="hero__title"
          initial={{ opacity: 0, y: 48 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.95, ease: [0.22, 1, 0.36, 1], delay: 0.3 }}
        >
          Building scalable apps
          <span>across web, cloud &amp; embedded systems</span>
        </motion.h1>

        <motion.p
          className="hero__lead"
          initial={{ opacity: 0, y: 32 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.85, ease: [0.22, 1, 0.36, 1], delay: 0.44 }}
        >
          Results-driven engineer with experience in OOP, microservices, DevOps, and
          collaborative product delivery.
        </motion.p>

        <motion.div
          className="hero__actions"
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1], delay: 0.56 }}
        >
          <button type="button" className="btn btn--fill" onClick={() => scrollTo('#experience')}>
            Experience
          </button>
          <button type="button" className="btn btn--ghost" onClick={() => scrollTo('#contact')}>
            Get in touch
          </button>
        </motion.div>
      </motion.div>

      <motion.div
        className="hero__scroll"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1.1, duration: 0.8 }}
      >
        <span>Scroll</span>
        <motion.span
          className="hero__scroll-line"
          animate={{ scaleY: [0.4, 1, 0.4], opacity: [0.4, 1, 0.4] }}
          transition={{ duration: 1.8, repeat: Infinity, ease: 'easeInOut' }}
        />
      </motion.div>
    </section>
  );
};

export default Hero;
